import React from "react";
import { Alert } from "antd";
import { useDocumentDisplayCurrency } from "@/ProposalBuilder/hooks/useDocumentDisplayCurrency";

const CatalogCurrencyHint: React.FC<{ className?: string }> = ({
	className
}) => {
	const { isLegacy, quoteCurrency, companyCurrency, effectiveRate } =
		useDocumentDisplayCurrency();

	if (
		isLegacy ||
		!quoteCurrency ||
		!companyCurrency ||
		quoteCurrency === companyCurrency ||
		!effectiveRate ||
		effectiveRate <= 0
	) {
		return null;
	}

	return (
		<Alert
			type="info"
			showIcon
			className={className}
			message={`Prices are entered in the catalog currency (${companyCurrency}). They will be converted to ${quoteCurrency} (× ${effectiveRate}) when this product is added to this document.`}
			data-testid="catalog-currency-hint"
		/>
	);
};

export default CatalogCurrencyHint;
